<template>
    <div style="overflow-x:auto; margin-top: 20px">
        <table id="fields_table" class="table table-responsive table-hover table-mail fieldsTable">
            <thead>
            <tr>
                <th>Área de Atuação</th>
                <th>Crédito</th>
            </tr>
            </thead>
        </table>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props:{
            fields:{
                type:Array
            }
        },
        data(){
            return {
                dataTable:null,
            }
        },
        mounted(){
            var vm = this;
            $(document).ready(function(){
                vm.dataTable = $('#fields_table').DataTable({
                    searching:false,
                    serverSide:true,
                    ajax:{
                        url:'/admin/configuracoes/fields/all',
                        method:'GET'
                    },
                    columns:[
                        {
                            data:'name',
                            render:function(data, type, row, meta)
                            {
                                return '<a target="_blank" href="/admin/configuracoes/fields/'+row.id+'">'+data+'</a>';
                            }
                        },
                        {
                            data:'credit_value',
                            render:function(data, type, row, meta)
                            {
                                return '<a target="_blank" href="/admin/configuracoes/fields/'+row.id+'">'+data+'</a>';
                            }
                        }
                    ]
                });
            });
        },
        methods: {
            filterTable(){
                this.dataTable.ajax.reload();
            }
        }
    }
</script>